"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Authors = _interopRequireDefault(require("./Authors"));
var _styles = require("@material-ui/core/styles");
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function () {
  return {
    root: {
      '& .ms-aem-reference-el--title': {
        fontStyle: 'italic'
      }
    }
  };
});
var Dissertation = function Dissertation(props) {
  var authors = props.authors,
    year = props.year,
    title = props.title,
    publisher = props.publisher,
    publicationPlace = props.publicationPlace;
  var styles = useStyles();
  return __jsx("div", {
    className: "ms-aem-reference-type ms-aem-reference-type--dissertation ".concat(styles.root)
  }, authors.length > 0 && __jsx(_Authors.default, {
    authors: authors
  }), year && __jsx("span", {
    dangerouslySetInnerHTML: {
      __html: " ".concat(year, ".")
    }
  }), title && __jsx("span", null, __jsx("span", {
    className: "ms-aem-reference-el--title",
    dangerouslySetInnerHTML: {
      __html: " ".concat(title, ".")
    }
  }), __jsx("span", null, " [dissertation].")), publicationPlace && __jsx("span", {
    dangerouslySetInnerHTML: {
      __html: " ".concat(publicationPlace, ":")
    }
  }), publisher && __jsx("span", {
    dangerouslySetInnerHTML: {
      __html: " ".concat(publisher, ".")
    }
  }));
};
var _default = Dissertation;
exports.default = _default;